module.exports = __webpack_public_path__ + "static/media/qh.6339f1ad.JPG";